export const leadGroupsKeys = {
  all: () => ['LEAD_GROUPS'],
  list: ({ page, search }: { page: number; search: string }) => [
    'LEAD_GROUPS',
    page,
    search,
  ],
  single_group: (leadGroupId: number) => ['LEAD_GROUPS', leadGroupId],
};
